<template>
  <svg
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.22222 1H7.5L10 3.25V9.5M6.11111 2.5V4.2C6.11111 4.36569 6.26035 4.5 6.44444 4.5H8.33333M0 3.25V10.25C0 10.6642 0.373096 11 0.833333 11H7.5C7.96024 11 8.33333 10.6642 8.33333 10.25V4.37426C8.33333 4.2947 8.29822 4.21839 8.2357 4.16213L6.48652 2.58787C6.42401 2.53161 6.33922 2.5 6.25082 2.5H0.833334C0.373096 2.5 0 2.83579 0 3.25Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  name: 'CopyIcon'
}
</script>
